import { create, v, w } from '@dojo/framework/core/vdom';
import { theme } from '@dojo/widgets/middleware/theme';
import isObject from 'lodash-es/isObject';

// make generated .d.ts file valid
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { WNodeFactory, WidgetProperties, DNode } from '@dojo/framework/core/interfaces';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { ThemeProperties } from '@dojo/framework/core/middleware/theme';

import { TopicWidgetProperties } from 'book-widgets/interfaces';
import { Accordion } from '@holmescorp/base-widgets/accordion2';

import css from '@holmescorp/book-widgets/css/topicpage.m.css';
import { isEleWithKids, extract_accordion_children } from '../../support/utils';

const factory = create({ theme }).properties<TopicWidgetProperties>();

export const VerticalAccordion = factory(({ properties, middleware: { theme } }) => {
	const { topicdata, additionalClasses = [] } = properties();
	const themeCss = theme.classes(css);

	const panes =
		isEleWithKids(topicdata) && isObject(topicdata) && Array.isArray(topicdata.children)
			? topicdata.children.flatMap((pane) => {
					return extract_accordion_children(pane);
			  })
			: [];

	const first = panes.find((pane) => {
		return 'key' in pane;
	});

	return v('div', { classes: [themeCss.accordion, themeCss.verticalAccordion, ...additionalClasses] }, [
		w(
			Accordion,
			{
				openKeys: first && first.key ? [first.key as string] : [],
				exclusive: true,
				headingLevel: 3,
				role: 'list',
				useContainer: false
			},
			panes
		)
	]);
});
